<template lang="html">
  <div class="page-category">
    <div class="category">
      <div class="category-one">
        <div class="category-left">
          <span class="category-item">
            <router-link type="text" :to="{ name: 'category', params: {type:'one'}, query: {id:0} }">
              <el-button type="text" :class="{'currentCate':currentCateOne==0}" @click="ChangeCate(0)">
                全部
              </el-button>
            </router-link>
          </span>
        </div>
        <div class="category-right">
          <span class="category-item" v-for="item in $store.state.categoryList" :key="item.id">
            <router-link type="text" :to="{ name: 'category', params: {type:'one'}, query: {id:item.id} }">
              <el-button type="text" :class="{'currentCate':currentCateOne==item.id}" @click="ChangeCate(item)">
                {{item.name}}
              </el-button>
            </router-link>
          </span>
        </div>
      </div>
      <div class="category-two" v-show="currentCateOne!==0">
        <span class="category-item" v-for="item in categoryListTwo" :key="item.id">
          <router-link type="text" :to="{ name: 'category', params: {type:'two'}, query: {id:item.id} }">
            <el-button type="text" :class="{'currentCate':currentCateTwo==item.id}" @click="ChangeCateTwo(item)">
              {{item.name}}
            </el-button>
          </router-link>
        </span>
      </div>
    </div>

    <div class="themenamelist">
      <el-row class="themename-box">
        <el-col :span="6" v-for="(item, index) in themenameList" :key="item.id" :class="['themename', {'themename-top':index<4}, {'themename-left':index%4===0}, {'themename-right':index%4===3}]">
          <el-card :body-style="{ padding: '0px' }" class="themename-card">
            <!-- <router-link :to="{ name: 'video', params: {type:item.liveFlag===0?'vod':'live',id:item.id} }" target="_blank" class="themename-image">
              <img :src="item.cover" :onerror="$store.state.errorImage" width="100%" height="56.25%">
            </router-link> -->
            <div class="themename-card-cover" :style="'background:url('+(item.cover)+') center center / cover no-repeat;'" @click="ViewVideo(item)" v-if="item.cover!=undefined&&item.cover!=''"></div>
            <div class="themename-card-cover" :style="'background:url('+($store.state.defaultImage)+') center center / cover no-repeat;'" @click="ViewVideo(item)" v-else></div>
            <div class="themename-card-bottom">
              <div class="themename-card-bottom1 over">
                <router-link :to="{ name: 'video', params: {type:item.liveFlag===0?'vod':'live',id:item.id} }" target="_blank">
                  {{item.name}}
                </router-link>
              </div>
              <div class="themename-card-bottom2 clearfix">
                <span class="lecturename">{{item.lecturerName}}</span>
              </div>
            </div>
          </el-card>
        </el-col>
        <div class="empty-data" style="height:300px;line-height:300px;" v-if="themenameList.length===0">
          暂无内容
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import Api from '@/api/api.js';

export default {
  inject: ['reload'],
  data() {
    return {
      // categoryList: this.$store.state.categoryList,
      categoryListTwo: [],
      themenameList: [],
      currentCate: this.$route.query.id,
      currentCateType: this.$route.params.type,
      currentCateid: 0,
      currentCateOne: 0,
      currentCateTwo: 0,
      currentPage: 1,
      pgTotalCount: 0,
      pgTotalPageNum: 0,
      scrollFlag: true
    }
  },
  async created() {
    await this.GetCategoryList();
    await this.GetCategoryThemeName();

    window.addEventListener("scroll", this.HandleScroll, true);
  },
  watch: {
    $route() {
      this.currentCate = this.$route.query.id;
      this.currentCateType = this.$route.params.type;
    },
    currentCate() {
      this.themenameList = [];
      this.currentPage = 1;
      this.scrollFlag = true;
      this.GetCategoryThemeName();
    },
    currentCateType() {
      this.themenameList = [];
      this.currentPage = 1;
      this.scrollFlag = true;
      this.GetCategoryThemeName();
    }
  },
  computed: {
    isAuthed() {
      return window.localStorage.USERID !== undefined;
    },
    loadFlag() {
      return this.themenameList.length < this.pgTotalCount && this.currentPage < this.pgTotalPageNum ? true : false;
    },
    categoryList() {
      return this.$store.state.categoryList || [];
    }
  },
  methods: {
    openSuccess(text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'success'
      });
    },
    openError(text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'error'
      });
    },
    async GetCategoryList() {
      let response = await Api.GetCategoryList();
      if (response.resCode === 0) {
        if (response.resList[0]) {
          this.$store.commit('setCategoryList', response.resList[0].resList);
        } else {
          return [];
        }
      } else if (response.resCode === -1001) {
        this.$store.commit('setUserinfo', {});
        this.$message({
          showClose: true,
          message: this.$store.state.message.tokenInvalid,
          type: 'error'
        });
        this.reload();
        return [];
      } else {
        this.$message({
          showClose: true,
          message: '数据异常！',
          type: 'error'
        });
        return [];
      }
    },
    async GetThemeNameList(param) {
      let response = await Api.GetThemeNameList(param);
      if (response.resCode === 0) {
        if (response.pgTotalCount !== undefined) this.pgTotalCount = response.pgTotalCount;
        if (response.pgTotalPageNum !== undefined) this.pgTotalPageNum = response.pgTotalPageNum;
        return response.resList || [];
      } else if (response.resCode === -1001) {
        this.$message({
          showClose: true,
          message: this.$store.state.message.tokenInvalid,
          type: 'error'
        });
        return [];
      } else {
        this.$message({
          showClose: true,
          message: this.$store.state.message.errorMsg,
          type: 'error'
        });
        return [];
      }
    },
    async GetCategoryThemeName() {
      if (isNaN(Number(this.currentCate))) return this.themenameList = await this.GetThemeNameList({});

      if (this.currentCate == '0') {
        this.currentCateid = 0;
        return this.themenameList = await this.GetThemeNameList({});
      }
      // this.currentCateOne = 0;

      if (this.currentCateType === 'one') {
        this.currentCateOne = Number(this.currentCate) || 0;
        this.$store.state.categoryList.forEach(async item => {
          if (item.id == this.currentCateOne) {
            this.categoryListTwo = item.resList || [];
            if (item.resList !== undefined) {
              if (item.resList[0].id !== undefined) {
                this.currentCateTwo = item.resList[0].id;
                this.themenameList = await this.GetThemeNameList({
                  category: this.currentCateTwo
                });
              }
            } else {
              this.themenameList = [];
            }
          }
        });
      } else if (this.currentCateType === 'two') {
        this.currentCateTwo = Number(this.currentCate) || 0;
        this.categoryList.forEach(async item => {
          if (item.resList !== undefined) {
            item.resList.forEach(item2 => {
              if (item2.id == this.currentCateTwo) {
                this.currentCateOne = item.id;
                this.categoryListTwo = item.resList || [];
              }
            });
          }
        });
        this.themenameList = await this.GetThemeNameList({
          category: this.currentCateTwo
        });
      }

      this.currentCateid = this.currentCateTwo;
    },
    async HandleScroll() {
      var scrollTop = document.querySelector("#app").scrollTop;
      var scrollHeight = document.querySelector("#app").scrollHeight;
      var sliderHeight = document.documentElement.clientHeight || document.body.clientHeight; //变量scrollHeight是滚动条的总高度
      let height = Math.abs(scrollHeight - sliderHeight - scrollTop);
      if (height < 300 && this.loadFlag && this.scrollFlag) {
        // 当滚动条滚动到距离底部还有300px的时候加载类容
        //请求数据接口
        this.scrollFlag = false;
        this.currentPage++;
        let params = {
          pgPageNum: this.currentPage
        };
        if (this.currentCateid != 0) params['category'] = this.currentCateid;

        let array1 = this.themenameList;
        let array2 = await this.GetThemeNameList(params);
        this.themenameList = array1.concat(array2);
        this.scrollFlag = true;
      } else {
        // 当滚动条滚动到距离底部大于300px的时候加载类容
      }
    },
    async ChangeCate(cate) {
      if (cate !== 0) {
        this.currentCateOne = cate.id;
        if (cate.resList !== undefined) {
          this.currentCateTwo = cate.resList[0].id;
          this.categoryListTwo = cate.resList;
          let response = await this.GetThemeNameList({
            category: cate.resList[0].id
          });
          this.themenameList = response || [];
        } else {
          this.currentCateTwo = 0;
          this.categoryListTwo = [];
          this.themenameList = [];
        }
      } else {
        this.currentCateOne = cate;
        this.themenameList = await this.GetThemeNameList({});
      }
    },
    async ChangeCateTwo(cate) {
      this.currentCateTwo = cate.id;
      let response = await this.GetThemeNameList({
        category: cate.id
      });
      this.themenameList = response || [];
    },
    ViewVideo(item) {
      // if (this.isAuthed) {
        let route = this.$router.resolve({
          name: "video",
          params: {
            type: item.liveFlag === 0 ? 'vod' : 'live',
            id: item.id
          }
        });
        window.open(route.href, '_blank');
      // } else {
      //   this.$store.commit('setIsLogin', !this.$store.state.isLogin);
      // }
    }
  }
}
</script>

<style lang="css">
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__arrow {
    width: 60px !important;
    height: 60px !important;
  }

  .el-carousel__arrow .el-icon-arrow-left,
  .el-carousel__arrow .el-icon-arrow-right {
    font-size: 30px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>
